export const category_list = [
  // {
  //   name: "New Games",
  //   path: "news",
  // },
  {
    name: "NETENT",
    path: "netent",
  },
  {
    name: "EGT",
    path: "egt",
  },
  {
    name: "EGT_EQ",
    path: "egt_eq",
  },
  {
    name: "EGT_DIGITAL",
    path: 'egt_digital'
  },
  {
    name: "PRAGMATIC",
    path: "pragmatic",
  },
  {
    name: "NOVOMATIC",
    path: "novomatic",
  },
  {
    name: "PATE",
    path: "pate",
  },
  {
    name: "MERKUR",
    path: 'merkur'
  },
  {
    name: "AMATIC",
    path: "amatic",
  },
  {
    name: "QUICKSPIN",
    path: "quickspin",
  },
  {
    name: "AINSWORTH",
    path: "ainsworth",
  },
  {
    name: "NETENT2",
    path: "netent2",
  },
  {
    name: "AMATIC2",
    path: "amatic2",
  },

  {
    name: "NOVOMATIC2",
    path: "novomatic2",
  },
  {
    name: "ARISTOCRAT2",
    path: "aristocrat",
  },
  {
    name: "PlayNGo",
    path: "playngo",
  },
  {
    name: "River",
    path: "river",
  },
  {
    name: "PragmaticPlay",
    path: "pragmaticplay",
  },
  {
    name: "Scientific",
    path: "scientific",
  },
  {
    name: "Yggdrasil",
    path: "yggdrasil",
  },
  {
    name: "Zeppelin",
    path: "zeppelin",
  },
];